<script lang="ts" setup>
  import { StepIndicator } from '@tundr/stepper';
  import { rowClass, textCenterClass } from '@tundr/theme';
  import { computed } from 'vue';
  import Button from '../../Button/Button.vue';
  import {
    actionsWrapperClass,
    headerContainerClass,
    headerLeftSectionClass,
    sectionHeaderClass,
    stepIndicatorClass,
    subtitleWrapperClass,
  } from './SectionHeader.css';
  import type { SectionHeaderProps } from './SectionHeader.types';

  const props = defineProps<SectionHeaderProps>();

  const titleClasses = computed(() => ({
    [textCenterClass]: props.centeredText,
  }));

  const subtitleClasses = computed(() => ({
    [subtitleWrapperClass]: true,
    [textCenterClass]: props.centeredText,
  }));
</script>
<template>
  <div :class="sectionHeaderClass">
    <slot name="step">
      <div :class="stepIndicatorClass">
        <StepIndicator
          v-if="currentStep && totalSteps"
          :current-step="currentStep"
          :total-steps="totalSteps"
        />
      </div>
    </slot>
    <div :class="headerContainerClass">
      <div :class="headerLeftSectionClass">
        <slot name="title">
          <div :class="rowClass">
            <h1 :class="titleClasses">{{ title }}</h1>
          </div>
        </slot>
        <div :class="subtitleClasses">
          <slot name="subtitle"> <p v-if="subtitle">{{ subtitle }}</p> </slot>
        </div>
        <slot name="extra-content" />
      </div>
      <div :class="actionsWrapperClass">
        <slot name="actions">
          <Button
            v-for="(action, index) in actions"
            :key="action.testId || `action-${index}`"
            v-bind="action"
            @click="action.onClick"
          />
        </slot>
      </div>
    </div>
  </div>
</template>
